import { dateLib } from "../lib/dateLib.js";
export function getDateLib(customLib) {
    return {
        ...dateLib,
        ...customLib
    };
}
//# sourceMappingURL=getDateLib.js.map